(function () {
    'use strict';
    angular.module('app').controller('rename', rename);
    rename.$inject = ['$location', '$scope', '$rootScope', 'gridDataService', '$q', '$timeout', '$mdDialog', 'records', 'command', 'commandService', 'loginService', 'editEmailsService', 'workAreaService', 'zcs', 'selectionCommandService', 'autoNameService'];
    function rename($location, scope, $rootScope, gridDataService, $q, $timeout, $mdDialog, records, command, commandService, loginService, editEmailsService, workAreaService, zcs, selectionCommandService, autoNameService) {

        // =====================================
        // On Load.
        // =====================================

        // Initialize.
        scope.ACN_RENAME = 106;
        scope.xyz = { autoNameMode: false, autoNameEnable: false, autoNameList: [], bReadyForOK: false, newName: "", maxFileNameLength: -1, selectionCount: +0 };
        scope.processingLabel = loginService.resourceStrings["PROCESSING"];

        // On click of the command.
        scope.onRenameButtonClicked = function (slx) {

            selectionCommandService.GetMaxFilenameLength().then(function (data) {
                scope.xyz.maxFileNameLength = data;
            }, function (response) {
                selectionCommandService.ShowEx(response); // Nothing more to do.
            });

            // Ping ACS. On failure, close dialog.
            zcs.Ping(true).then(function (response) {
                // List.
                scope.slx = slx;

                // Dialog config.
                scope.heading = loginService.resourceStrings["TITLE_RENAME"];
                scope.newNameLabel = loginService.resourceStrings["NEW_NAME"];
                scope.autoNameLabel = loginService.resourceStrings["AUTONAME"];
                scope.filesLabel = loginService.resourceStrings["FILES_TO_RENAME"];
                scope.OK = loginService.resourceStrings["OK"]; // "OK";
                scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";

                autoNameService.IsAutoNameEnabled().then(function (bEnabled) { scope.xyz.autoNameEnable = bEnabled; });

                // Dialog config columns.
                //scope.doColumns();
                scope.gridOptions.columnDefs = [
                  { name: 'Name', field: 'name', width: '33%', minWidth: '100' },
                  { name: 'New Name', field: 'newName', width: '33%', minWidth: '100' }];
                var colName = loginService.resourceStrings["SCHEMA_S_LONGNAME"];
                scope.gridOptions.columnDefs[0].name = colName;
                scope.gridOptions.columnDefs[1].name = scope.newNameLabel;

                // For each selection item, add a row to the grid.
                scope.gridOptions.data = [];
                var index = 0;
                angular.forEach(scope.slx.list, function (item) {
                    // Add item.
                    scope.gridOptions.data.push({
                        index: index,
                        selectionItem: item,
                        isSelected: true,
                        name: item.filename, newName: item.filename
                    });
                    index++;
                });

                // Enables.
                scope.xyz.bReadyForOK = true;

                // Select rows.
                $timeout(function () {
                    refreshGrid();

                    // Select 1st row only.
                    //scope.gridApi.selection.selectAllRows();
                    scope.gridApi.selection.clearSelectedRows();
                    scope.gridApi.selection.selectRow(scope.gridOptions.data[0]);

                    $timeout(function () {
                        refreshGrid();
                    }, 2000);
                }, 500);

            }, function () {
                // Handle error.
                $mdDialog.hide();
                $rootScope.msgBoxShow(loginService.resourceStrings["ACS_FAILED_TO_CONNECT"], loginService.resourceStrings["ACS_REQUIRED"]);
            });
        };


        // =====================================
        // User interaction.
        // =====================================


        scope.onRenameDocDialogAutoName = function () {
            var deferred = $q.defer();
            scope.xyz.autoNameMode = false;

            $mdDialog.show({
                controller: 'autoNameDialog',
                templateUrl: 'app/autoname/autoNameDialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                fullscreen: false,
                skipHide: true,
                locals: {
                    defaultExtension: scope.getDefaultExtension(),
                    numberOfDocuments: scope.gridOptions.data.length
                }
            })
                .then(function () {
                    // OK
                    if ($rootScope.dlgReturn != null && $rootScope.dlgReturn.autoNameOK == true) {
                        scope.xyz.autoNameList = $rootScope.dlgReturn.autoNameList;
                        scope.applyAutoNameList();
                        scope.xyz.autoNameMode = true;
                        scope.xyz.newName = "";
                        scope.gridOptions.ena
                    }
                    deferred.resolve();
                }, function () {
                    //cancel
                    deferred.reject();
                });
            return deferred.promise;
        }

        scope.getDefaultExtension = function () {
            if (scope.gridApi.selection.getSelectedRows().length > 0) {
                var item = scope.gridApi.selection.getSelectedRows();
                scope.defaultExtension = scope.getDocExtension(item[0].name);
            }
            else if (scope.gridOptions.data.length > 0)
                scope.defaultExtension = scope.getDocExtension(scope.gridOptions.data[0].name);

            return scope.defaultExtension;
        }

        scope.getDocExtension = function (filename) {
            var index = filename.lastIndexOf('.');
            if (index != -1)
                return filename.substr(index);
            else
                return "";
        }

        scope.applyAutoNameList = function () {
            var index = 0;
            var extension = "";

            scope.gridOptions.multiSelect = true; //temp set to true.
            scope.gridApi.selection.selectAllRows();

            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (gridItem) {
                extension = "";
                if (gridItem.name.lastIndexOf('.') > 0) {
                    extension = gridItem.name.substr(gridItem.name.lastIndexOf('.'));
                }
                gridItem.newName = scope.xyz.autoNameList[index] + extension;
                index++;
            });

            scope.gridOptions.multiSelect = false; //set back to false
            scope.gridApi.selection.clearSelectedRows(); //clear selections as they can only select one again
        }

        scope.onNewNameChanged = function () {
            scope.xyz.newName
            // Should only be one.
            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (gridItem) {
                // If checked.
                gridItem.newName = scope.xyz.newName;
                return; // Should only be one, so return after the first.

            });
        }

        //
        // On selection changed in the grid.
        //
        scope.selectItem = function (item) {
            scope.xyz.selectionCount = scope.gridApi.selection.getSelectedRows().length;
            if (scope.xyz.selectionCount < 1)
                scope.xyz.newName = "";
            else {
                // Should only be one.
                angular.forEach(scope.gridApi.selection.getSelectedRows(), function (gridItem) {
                    // If checked.
                    scope.xyz.newName = gridItem.newName;
                    return; // Should only be one, so return after the first.
                });
            }

            if (scope.xyz.autoNameMode) {
                scope.gridApi.selection.clearSelectedRows();
                scope.xyz.newName = "";
            }
        }

        var renameItem2 = function (gridItem, autoNameFormatModel) {
            // Must be a promise.
            var deferred = $q.defer();

            // Execute.
            // Call the WebApi to do the command.
            //filename, tableNumber, fileId, majRev, minRev, workAreaId, newName

            if (!scope.xyz.autoNameMode) {
                selectionCommandService.RenameItem(
                    gridItem.selectionItem.filename, gridItem.selectionItem.tableNumber, gridItem.selectionItem.fileId, gridItem.selectionItem.majRev, gridItem.selectionItem.minRev,
                    gridItem.newName).then(function (response) {
                        // When that  returns, ...
                        var selectionCommandResults = response.data;
                        // Walk the list and add to our results list.
                        angular.forEach(selectionCommandResults.slx.list, function (si) {
                            scope.resultSLX.list.push(si);
                        });
                        // Call ACS to do the file operation.
                        zcs.ProcessFileOperationPacket(selectionCommandResults.fileOperationPacket, true).then(function (response) {
                            deferred.resolve();
                        }, function (response) {
                            selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                        });
                    }, function (response) {
                        selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                    }); 
            } else {
                selectionCommandService.RenameItem(
                    gridItem.selectionItem.filename, gridItem.selectionItem.tableNumber, gridItem.selectionItem.fileId, gridItem.selectionItem.majRev, gridItem.selectionItem.minRev,
                    gridItem.newName).then(function (renameResponse) {
                        var renameCommandResults = renameResponse.data;
                        // Call ACS to do the file operation.
                        // zcs.ProcessFileOperationPacket(selectionCommandResults.fileOperationPacket, true).then(function (response) {
                        zcs.ProcessFileOperationPacket(renameResponse.data.fileOperationPacket, true).then(function (response) {
                            if (renameCommandResults.ec != 0) {
                                // When that returns, walk the list from Rename and add to our results list.
                                var selectionCommandResults = renameResponse.data;
                                angular.forEach(selectionCommandResults.slx.list, function (si) {
                                    scope.resultSLX.list.push(si);
                                });
                                deferred.resolve();
                            } else {
                                // Update the database record
                                autoNameService.AutoNameUpdateRecord(gridItem.selectionItem, autoNameFormatModel).then(function () {
                                    // Update the document
                                    autoNameService.UpdateDocument(gridItem.selectionItem, autoNameFormatModel, gridItem.newName).then(function () {
                                        // When that returns, walk the list from Rename and add to our results list.
                                        var selectionCommandResults = renameResponse.data;
                                        angular.forEach(selectionCommandResults.slx.list, function (si) {
                                            scope.resultSLX.list.push(si);
                                        });
                                        deferred.resolve();
                                    }, function (response) {
                                        selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                                    });
                                }, function (response) {
                                    selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                                });
                            }
                   }, function (response) {
                        selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); 
                        deferred.resolve();
                    });
               }, function (response) {
                   selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                });
            }

            return deferred.promise;
        }

        var renameItem = function (gridItem, autoNameFormatModel) {
            // Each item must be a promise.
            var deferred = $q.defer();
            // Do a vault check, will still make calls even if not applicable.
            //selectionCommandService.CheckOutVaultCheck(gridItem.selectionItem.detailedInfo.libId, gridItem.selectionItem.fileId, scope.alreadyCheckedArray).then(function (response) {
            selectionCommandService.VaultFileCheck(scope.ACN_RENAME, gridItem.selectionItem.fileId).then(function (response) {
                // Process the vault check.
                zcs.ProcessFileOperationPacket(response.data, true).then(function (response) {
                    var bHadError = false;

                    // If the vault check failed, add an error.
                    if (response != null && response.data != null && response.data.fileOperations != null && response.data.fileOperations.length > 0 ) {
                        angular.forEach(response.data.fileOperations, function (item) {
                            // If we haven't reported an error for this fileId yet, and this one is an error.
                            if (bHadError == false && item.ec != 0) {
                                bHadError = true; // Set flag before calling next async call.
                                selectionCommandService.ErrorCode(gridItem.selectionItem, item.ec).then(function (response) {
                                    scope.resultSLX.list.push(response.data);
                                    deferred.resolve();
                                }, function (response) {
                                    selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                                });
                            }
                        });
                    }

                    if(bHadError) {
                        // Will have been resolved already, don't do more work.
                    }
                    else {
                        var LT_LINKED = 76; // 'L'; ApiTypes.ADLINKTYPE.LT_LINKED
                        if (gridItem.selectionItem.detailedInfo.linkType != LT_LINKED) {
                            renameItem2(gridItem, autoNameFormatModel).then(function () {
                                // When it is done, we are done.
                                deferred.resolve();
                            }, function () {
                                deferred.resolve(); // Called function will not reject.
                            });
                        }
                        else {

                            // If the document is in a Work Area, ...
                            var O_DUP = 70; // 'F'; // OPFLAG.O_DUP
                            var O_NEW = 81; // 'Q'; // OPFLAG.O_NEW
                            var O_OUT = 83; // 'S'; // OPFLAG.O_OUT
                            var opFlag = gridItem.selectionItem.detailedInfo.opFlag;
                            if (opFlag == O_DUP || opFlag == O_NEW || opFlag == O_OUT) {
                                selectionCommandService.GetAccessPath(gridItem.selectionItem.tableNumber, gridItem.selectionItem.fileId, gridItem.selectionItem.majRev, gridItem.selectionItem.minRev).then(function (data) {
                                    var filePNE = data.accessPNE;
                                    zcs.TestAccess(filePNE, true).then(function (response) {
                                        var bOK = response;
                                        if (!bOK) {
                                            var ec = 82; // ErrorCodes.ErrorCode.ECFILEBUSY
                                            selectionCommandService.ErrorCode(gridItem.selectionItem, ec).then(function (response) {
                                                scope.resultSLX.list.push(response.data);
                                                deferred.resolve();
                                            }, function (response) {
                                                selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                                            });
                                        }
                                        else {
                                            zcs.isFile(filePNE, true).then(function (data) {
                                                if (data == true) {
                                                    renameItem2(gridItem, autoNameFormatModel).then(function () {
                                                        // When it is done, we are done.
                                                        deferred.resolve();
                                                    }, function () {
                                                        deferred.resolve(); // Called function will not reject.
                                                    });
                                                }
                                                else {
                                                    var ec = 104; // ErrorCodes.ErrorCode.EC_FILE_MISSING_FROM_WORK
                                                    selectionCommandService.ErrorCode(gridItem.selectionItem, ec).then(function (response) {
                                                        scope.resultSLX.list.push(response.data);
                                                        deferred.resolve();
                                                    }, function (response) {
                                                        selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                                                    });
                                                }
                                            }, function (response) {
                                                selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                                            });
                                        }
                                    }, function () {
                                        selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                                    });
                                }, function (response) {
                                    selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                                });
                            }
                            else {
                                renameItem2(gridItem, autoNameFormatModel).then(function () {
                                    // When it is done, we are done.
                                    deferred.resolve();
                                }, function () {
                                    deferred.resolve(); // Called function will not reject.
                                });
                            }
                        } // LINKED
                    }
                }, function (response) {
                    selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                }); // ProcessFileOperationPacket - VaultCheck
            }, function (response) {
                selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
            }); // CheckOutVaultCheck
            // Return the promise for doing the work.
            return deferred.promise;
        };

        // Call back from the dialog.
        var questionBox_PostCloseCallback_Overwrite = function (param1, param2, result) {
            // Remember for next time.
            scope.answers.overwrite = result;
            var gridItem = param1;
            var deferred = param2;
            // If we are to process the item, ...
            if (result == 'Y' || result == 'YtoAll') {
                // Do the work now.
                renameItem(gridItem, $rootScope.dlgReturn.autoNameFormatModel).then(function () {
                    // When that is done, we are done.
                    deferred.resolve();
                }, function () {
                    deferred.resolve(); // Called function will not reject.
                });
            }
            else { // Or if we are not process it, ...
                // Then we are done.
                deferred.resolve();
            }
        }

        // Do one item.
        var doOne = function (list, workNumber) {
            // Each item must be a promise.
            var deferred = $q.defer();
            // Get the item from the grid.
            var gridItem = list[workNumber];

            // If name and newName are the same, skip it all.
            if (gridItem.name == gridItem.newName
                || gridItem.newName.length < 1) {
                deferred.resolve();
                return deferred.promise;
            }

            if (scope.xyz.autoNameMode == true) {
                autoNameService.GenerateAutoName($rootScope.dlgReturn.autoNameFormatModel).then(function (response) {
                    var autoNameFormatModelNew = response.data;
                    gridItem.newName = autoNameFormatModelNew.generatedName + scope.getDocExtension(gridItem.name);
                    renameItem_Control(gridItem, autoNameFormatModelNew).then(function (response) {
                        deferred.resolve();
                    }, function (response) {
                        deferred.reject();
                    });
                }, function (response) {
                    selectionCommandService.ShowEx(response); scope.xyz.processing = false;
                });
            }
            else {
                renameItem_Control(gridItem, null).then(function (response) {
                    deferred.resolve();
                }, function (response) {
                    deferred.reject();
                });
            }
       
            // Return the promise for doing the work.
            return deferred.promise;
        }

        var renameItem_Control = function (gridItem, autoNameFormatModelNew) {
            var deferred = $q.defer();

            scope.processingLabel = loginService.resourceStrings["PROCESSING"] + " " + loginService.resourceStrings["FILENAME"] + ": " + gridItem.selectionItem.filename;

            var opFlag = gridItem.selectionItem.detailedInfo.opFlag;
            selectionCommandService.GetAccessPathIfWork(gridItem.selectionItem.tableNumber, gridItem.selectionItem.fileId, gridItem.selectionItem.majRev, gridItem.selectionItem.minRev).then(function (data) {
                var filePNE = data.accessPNE;
                if (filePNE.length > 0)
                    filePNE = filePNE.replace(gridItem.selectionItem.filename, gridItem.newName);

                // This dialog has the WorkArea combo be a global. 
                // It is not applied to the row in the grid when it changes.
                //var filePNE = scope.xyz.selectedWorkAreaItem.path + "\\" + gridItem.newName;

                // Collision check - local.
                zcs.isFile(filePNE, true).then(function (response) {
                    var bExistsLocally = response;
                    // Collision check - server.
                    //checkOutService.CheckOutCollisionCheck({ filename: gridItem.newName, workAreaId: gridItem.selectionItem.detailedInfo.targetId, bExistsLocally: bExistsLocally }).then(function (response) {
                    //    var opFlag = response.data;
                    //    var O_DUP = 70; // 'F'; // OPFLAG.O_DUP
                    //    var O_NEW = 81; // 'Q'; // OPFLAG._NEW
                    //    if (opFlag == O_NEW || opFlag == O_DUP) {
                    selectionCommandService.CollisionCheck(scope.ACN_RENAME, gridItem.selectionItem.fileId, gridItem.newName, "", gridItem.selectionItem.detailedInfo.targetId, bExistsLocally).then(function (response) {
                        var collisionCheckResponse = response.data;
                        if (collisionCheckResponse.bCanOverwrite) {
                            // If YtoAll, then fall through to checkOutItem.
                            if (scope.answers.overwrite != 'YtoAll') {
                                if (scope.answers.overwrite == 'NtoAll') {
                                    deferred.resolve();
                                    return deferred.promise;
                                }
                                // Ask 'Overwrite?' with Y/N/YtoAll/NtoAll
                                // Use overwrite question - work area.
                                // Use new name as filename.
                                $rootScope.questionBoxShow(gridItem, deferred, gridItem.newName, //gridItem.selectionItem.filename,
                                    loginService.resourceStrings["FILE_EXISTS_IN_WA"], // "File exists in the WorkArea.",
                                    loginService.resourceStrings["OVERWRITE_QUESTION_WORKAREA"], // "Overwrite?",
                                    questionBox_PostCloseCallback_Overwrite)
                                return deferred.promise;
                            }
                        }
                        renameItem(gridItem, autoNameFormatModelNew).then(function () {
                            deferred.resolve();
                        }, function () {
                            deferred.resolve(); // Called function will not reject.
                        });
                    }, function (response) {
                        selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                    });
                }, function () {
                    selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                });
            }, function (response) {
                selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
            });

            // Return the promise for doing the work.
            return deferred.promise;

        }

        // Walk through each item in the grid.
        var doLoop = function (list, workNumber) {
            // Each item must be a promise.
            var deferred = $q.defer();

            // Do one item.
            doOne(list, workNumber).then(function () {
                // When that is done, ...
                // Incement the item number that we are going to work on.
                workNumber++;
                // If we are still in the list, ...
                if (workNumber < list.length) {
                    // Recurse on the next item.
                    doLoop(list, workNumber).then(function () {
                        // When that is done. Resolve the promise from before.
                        deferred.resolve();
                    }, function () {
                        deferred.resolve(); // Called function will not reject.
                    });
                }
                else { // We are done with the list.
                    // Resolve this item.
                    deferred.resolve();
                    // Return the promise.
                    return deferred.promise;
                }
            }, function () {
                deferred.resolve(); // Called function will not reject.
            });

            // Return the promise for the current item.
            return deferred.promise;
        }

        // On click OK.
        scope.onRenameDialogOK = function () {
            // Start working.
            scope.xyz.processing = true;
            scope.answers = {};
            scope.answers.overwrite = 'N';
            scope.resultSLX = { mode: 0, order: 0, list: [] };
            scope.alreadyCheckedArray = [];

            // Just use the combo.
            //// All items go to the same work area.
            //// Update the selection item. 
            //angular.forEach(scope.slx.list, function (item) {
            //    item.commandParams = {};
            //    item.commandParams.eWorkAreaId = scope.xyz.selectedWorkAreaItem.workAreaId;
            //});

            //zcs.isDirectory(scope.xyz.selectedWorkAreaItem.path).then(function (response) {
            //    if (!response.data) {
            //        scope.xyz.processing = false;
            //        $rootScope.msgBoxShow(loginService.resourceStrings["WORK_AREA_ACCESS"], "");
            //        return;
            //    }

                // Start the loop.
                var workNumber = 0;
                doLoop(scope.gridOptions.data, workNumber).then(function () {
                    // Handle errors.
                    var slx = scope.resultSLX;
                    var atLeastOneError = false;
                    angular.forEach(slx.list, function (item) {
                        if (atLeastOneError == false) {
                            if (item.ec != 0) {
                                atLeastOneError = true;
                                if (atLeastOneError) {
                                    commandService.launchErrors({ slx: slx });
                                    //$rootScope.$broadcast('showErrorList', { slx: response.data });
                                }
                            }
                        }
                    });

                    // Close the dialog when finished.
                    $mdDialog.hide();

                    // Done.
                    scope.xyz.processing = false;
                    //console.log("gridDataService.updateGridRecords");
                    gridDataService.updateGridRecords(slx.list);
                }, function () {
                    scope.xyz.processing = false;
                });
            //}, function () {
            //    scope.xyz.processing = false;
            //});

        };

        // On click Cancel.
        scope.onRenameDialogCancel = function () {
            // Close dialog.
            $mdDialog.hide();
        };

        // =====================================
        // Grid.
        // =====================================

        // Called after all rows are selected.
        var refreshGrid = function () {
            scope.gridApi.grid.handleWindowResize();
            scope.gridApi.grid.refreshCanvas();
            scope.gridApi.grid.refresh();
        }

        // Called after the grid has been initialized.
        var onRegisterApi = function (gridApi) {
            scope.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged(scope, scope.selectItem);
            gridApi.selection.on.rowSelectionChangedBatch(scope, scope.selectItem);
            switch (command) {
                case "rename":
                    scope.onRenameButtonClicked(records);
                    break;
            }
        }

        scope.gridApi = {};

        scope.gridOptions = {
            data: [],
            enableSelectionBatchEvent: true,
            multiSelect: false,
            modifierKeysToMultiSelect: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            useExternalSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: 'Name', field: 'name', width: '33%', minWidth: '100' },
                { name: 'New Name', field: 'newName', width: '33%', minWidth: '100' }],
            onRegisterApi: onRegisterApi
        }

        // This was an old way of being called by the toolbar.
        //scope.$on('checkOutButtonClicked', function (event, arg) {
        //    scope.onCheckOutButtonClicked(arg.slx);
        //});

    }
})();
